import React from 'react';
import classes from './ProductList.module.css';
import ProductListItem from '../ProductListItem/ProductListItem';

const ProductList = (props) => {
    const products = props.products;
    //console.log(products);
    //console.log("FILTERS : " + props.filter);
    //const show = (props.filter == '' || (props.filter != '' &&  (section.sub_category[0] == props.filter)));

    return (
        <div className={classes.ProductList}>   
            {products.map((section, index) => (
                (props.filter === '' || (props.filter !== '' &&  (section.sub_category[0] === props.filter)) 
                    ? ((<div className={classes.ProductSubList} key={section.id}>
                        {section.hasOwnProperty('sub_category') ?  <h4>{section.sub_category[0]}</h4> : null}
                        {section.hasOwnProperty('cat_description') 
                            ?  <div className={classes.ProductSubListInfo}>{section.cat_description}</div>
                            : null}
                        
                        <ul>
                            {section.items.map(item => <li key={item.name[0]}>
                                <ProductListItem product={item} takeAway={props.takeAway} key={item.id}/>
                                </li>)}
                        </ul>
                    
                    </div>))
                    : null)
            ))}
                    
                        


        </div>
    )
}

export default ProductList;